import { render, staticRenderFns } from "./Direccio.vue?vue&type=template&id=2beac3bf&"
import script from "./Direccio.vue?vue&type=script&lang=js&"
export * from "./Direccio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports